module.exports = __webpack_public_path__ + "img/no-jianli.466646c8.png";